import { Flex, Text, ButtonLink } from '@backstage/ui';
import { NoDataIllustration } from './no-data-illustration.component';
import styles from './empty-state.module.css';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick?: () => void;
    href?: string;
  };
}

export const EmptyState = ({ title, description, action }: EmptyStateProps) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    gap="4"
    className={styles.container}
  >
    <NoDataIllustration />
    <Flex direction="column" align="center" gap="2" className={styles.textWrap}>
      <Text variant="title-small" weight="bold">
        {title}
      </Text>
      {description && (
        <Text variant="body-medium" color="secondary">
          {description}
        </Text>
      )}
    </Flex>
    {action && (
      <ButtonLink
        {...(action.href ? { href: action.href } : {})}
        onClick={action.onClick}
      >
        {action.label}
      </ButtonLink>
    )}
  </Flex>
);
